/*
 * Panier « vendeur » du tiroir (suggestions, minuteur, livraison estimée, ajout en un clic, mémoire du dernier
 * produit consulté). Sorti du HTML de chaque page (−25 Ko de JS en ligne, mis en cache par le navigateur) :
 * chargé par snippets/cart-drawer.liquid en « defer » — il s'exécute à la fin de la lecture du HTML, comme avant
 * (son travail principal attendait déjà DOMContentLoaded). Seule valeur Liquid : window.__hzPanierProduit.
 */
(function () {
  if (window.__panierVendeur) return;
  window.__panierVendeur = true;

  var CLE_VUS = 'panier-produits-vus';
  var produitPage = window.__hzPanierProduit != null ? window.__hzPanierProduit : null;

  function lireVus() {
    try { return JSON.parse(sessionStorage.getItem(CLE_VUS) || '[]') || []; } catch (e) { return []; }
  }

  /* 1. Dernier produit consulté */
  (function memoriser() {
    var id = produitPage;
    try {
      var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
      if (!id && meta && meta.page && meta.page.pageType === 'product' && meta.product) id = meta.product.id;
    } catch (e) {}
    if (!id) return;
    id = String(id);
    var vus = lireVus().filter(function (x) { return String(x) !== id; });
    vus.unshift(id);
    try { sessionStorage.setItem(CLE_VUS, JSON.stringify(vus.slice(0, 12))); } catch (e) {}
  })();

  function racineUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  var formater = null;
  function prix(cents, bloc) {
    var format = (bloc && bloc.getAttribute('data-format')) || '';
    var devise = (bloc && bloc.getAttribute('data-devise')) || 'EUR';
    if (formater && format) {
      try { return formater(cents, format, devise); } catch (e) {}
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'fr', { style: 'currency', currency: devise }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2); }
  }
  import('@theme/money-formatting').then(function (m) { formater = m.formatMoney; }).catch(function () {});

  /* 2. Suggestions */
  var cacheRecos = {};
  function charger(base, intention) {
    var url = racineUrl() + 'recommendations/products.json?product_id=' + encodeURIComponent(base) + '&limit=8&intent=' + intention;
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : { products: [] }; })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return []; });
  }
  function recos(base) {
    if (!cacheRecos[base]) {
      cacheRecos[base] = charger(base, 'complementary').then(function (a) {
        if (a.length >= 6) return a;
        return charger(base, 'related').then(function (b) { return a.concat(b); });
      });
    }
    return cacheRecos[base];
  }

  function majFleches(bloc) {
    var piste = bloc.querySelector('[data-sugg-piste]');
    var fleches = bloc.querySelector('[data-sugg-fleches]');
    if (!piste || !fleches) return;
    var deborde = piste.scrollWidth > piste.clientWidth + 4;
    if (fleches.hidden === deborde) fleches.hidden = !deborde;
    var prec = fleches.querySelector('[data-sugg-prec]');
    var suiv = fleches.querySelector('[data-sugg-suiv]');
    var auDebut = piste.scrollLeft <= 2;
    var aLaFin = piste.scrollLeft >= piste.scrollWidth - piste.clientWidth - 2;
    if (prec && prec.disabled !== auDebut) prec.disabled = auDebut;
    if (suiv && suiv.disabled !== aLaFin) suiv.disabled = aLaFin;
  }

  function completer(bloc, manque, exclus, rang, signature) {
    var base = bloc.getAttribute('data-base');
    var modele = bloc.querySelector('template[data-sugg-modele]');
    var piste = bloc.querySelector('[data-sugg-piste]');
    if (!base || !modele || !piste) return;
    recos(base).then(function (liste) {
      if (!bloc.isConnected || bloc.getAttribute('data-pret') !== signature) return;
      var deja = {};
      exclus.forEach(function (x) { deja[String(x)] = true; });
      var ajoutes = 0;
      liste.forEach(function (p) {
        if (ajoutes >= manque || !p || !p.available || deja[String(p.id)]) return;
        var variantes = p.variants || [];
        var v = null;
        for (var i = 0; i < variantes.length; i++) { if (variantes[i].available) { v = variantes[i]; break; } }
        if (!v) return;
        deja[String(p.id)] = true;
        var carte = modele.content.firstElementChild.cloneNode(true);
        carte.style.order = String(rang + ajoutes);
        carte.setAttribute('data-produit', p.id);
        carte.querySelectorAll('a').forEach(function (a) { a.href = p.url; });
        var img = carte.querySelector('img');
        var src = p.featured_image || (p.images && p.images[0]) || '';
        if (img && src) {
          img.src = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
        } else if (img) {
          img.remove();
        }
        var nom = carte.querySelector('.sugg__nom');
        if (nom) nom.textContent = p.title;
        var fin = carte.querySelector('.sugg__prix-final');
        if (fin) fin.textContent = prix(v.price, bloc);
        var barre = carte.querySelector('.sugg__prix-barre');
        if (barre && v.compare_at_price && v.compare_at_price > v.price) {
          barre.textContent = prix(v.compare_at_price, bloc);
          barre.hidden = false;
        }
        var bouton = carte.querySelector('[data-sugg-ajout]');
        if (bouton) {
          bouton.setAttribute('data-variant-id', v.id);
          bouton.setAttribute('aria-label', (bouton.getAttribute('data-libelle') || '') + ' : ' + p.title);
        }
        piste.appendChild(carte);
        ajoutes++;
      });
      if (ajoutes > 0 && bloc.hasAttribute('data-vide')) bloc.removeAttribute('data-vide');
      majFleches(bloc);
    });
  }

  function evaluer(bloc) {
    var vu = lireVus()[0] || '';
    var signature = (bloc.getAttribute('data-panier') || '') + '|' + vu;
    if (bloc.getAttribute('data-pret') === signature) return;

    var max = parseInt(bloc.getAttribute('data-max'), 10) || 3;
    var panier = (bloc.getAttribute('data-panier') || '').split(',').filter(Boolean);
    var cartes = Array.prototype.slice.call(bloc.querySelectorAll('[data-sugg-regle]'));
    var retenues = [];
    var pris = {};
    panier.forEach(function (x) { pris[x] = true; });

    cartes
      .map(function (c, i) { return { c: c, i: i, p: parseInt(c.getAttribute('data-priorite'), 10) || 99 }; })
      .sort(function (a, b) { return a.p - b.p || a.i - b.i; })
      .forEach(function (o) {
        var c = o.c;
        var id = c.getAttribute('data-produit') || '';
        var ok = c.getAttribute('data-ok') === 'true';
        if (ok && c.getAttribute('data-condition') === 'page') {
          ok = (c.getAttribute('data-pages') || '').split(',').indexOf(vu) > -1;
        }
        if (ok && id && pris[id]) ok = false;
        if (ok && retenues.length < max) {
          retenues.push(c);
          if (id) pris[id] = true;
        }
      });

    cartes.forEach(function (c) {
      var rang = retenues.indexOf(c);
      var cache = rang < 0 && !c.hasAttribute('data-force');
      if (c.hidden !== cache) c.hidden = cache;
      c.style.order = rang < 0 ? '' : String(rang);
    });
    bloc.querySelectorAll('[data-sugg-auto]').forEach(function (n) { n.remove(); });
    bloc.setAttribute('data-pret', signature);

    var vide = retenues.length === 0 && !bloc.querySelector('[data-force]');
    if (vide !== bloc.hasAttribute('data-vide')) {
      if (vide) bloc.setAttribute('data-vide', ''); else bloc.removeAttribute('data-vide');
    }
    if (retenues.length < max && bloc.getAttribute('data-auto') === 'true') {
      completer(bloc, max - retenues.length, Object.keys(pris), retenues.length, signature);
    }
    requestAnimationFrame(function () { majFleches(bloc); });
  }

  /* Écrit du HTML seulement s'il a changé. On compare à la sérialisation du navigateur
     (qui écrit par exemple &nbsp;) : comparer au texte source réécrirait à chaque fois,
     et l'observateur de mutations tournerait en boucle. */
  function ecrire(el, html) {
    if (el.__source === html && el.innerHTML === el.__serialise) return;
    el.innerHTML = html;
    el.__source = html;
    el.__serialise = el.innerHTML;
  }

  /* 3. Minuteur */
  function finMinuteur(el) {
    var cle = 'panier-minuteur-' + (el.getAttribute('data-cle') || '');
    var total = parseInt(el.getAttribute('data-seconds'), 10) || 0;
    var fin = 0;
    try { fin = parseInt(sessionStorage.getItem(cle), 10) || 0; } catch (e) {}
    var maintenant = Date.now();
    if (!fin || (fin <= maintenant && el.getAttribute('data-restart') === 'true')) {
      fin = maintenant + total * 1000;
      try { sessionStorage.setItem(cle, String(fin)); } catch (e) {}
    }
    return fin;
  }
  function peindreMinuteur(el) {
    var cible = el.querySelector('[data-minuteur-texte]');
    var total = parseInt(el.getAttribute('data-seconds'), 10) || 0;
    if (!cible || total <= 0) return;
    var reste = Math.max(0, Math.round((finMinuteur(el) - Date.now()) / 1000));
    /* temps écoulé sans « recommencer » : le minuteur disparaît (et son groupe s'il ne contient que lui) */
    if (reste === 0 && el.getAttribute('data-restart') !== 'true') {
      /* on masque aussi les conteneurs (groupe à fond coloré, zone du tiroir) qui n'affichent rien d'autre */
      var boite = el;
      var propre = function (n) { return (n.textContent || '').replace(/\s+/g, ''); };
      var moi = propre(el);
      while (boite.parentElement && boite.className.indexOf('cart-drawer__zone') < 0 && propre(boite.parentElement) === moi && !boite.parentElement.querySelector('img, video, input, button, a')) boite = boite.parentElement;
      boite.style.display = 'none';
      return;
    }
    var mn = Math.floor(reste / 60);
    var sec = reste % 60;
    var affiche = mn + ':' + (sec < 10 ? '0' + sec : sec);
    var gabarit = (el.getAttribute('data-template') || '')
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var html = gabarit.replace('[temps]', '<b>' + affiche + '</b>');
    ecrire(cible, html);
  }

  /* 4. Livraison estimée */
  function ajouterJours(depart, n, ouvres) {
    var d = new Date(depart.getTime());
    var reste = n;
    while (reste > 0) {
      d.setDate(d.getDate() + 1);
      var j = d.getDay();
      if (ouvres && (j === 0 || j === 6)) continue;
      reste--;
    }
    return d;
  }
  function peindreLivraison(el) {
    var titre = el.querySelector('[data-livraison-texte]');
    var modele = el.getAttribute('data-modele');
    if (!titre || !modele) return;
    var mini = parseInt(el.getAttribute('data-min'), 10) || 0;
    var maxi = parseInt(el.getAttribute('data-max'), 10) || mini;
    var ouvres = el.getAttribute('data-ouvres') === 'true';
    var limite = parseInt(el.getAttribute('data-limite'), 10);
    var depart = new Date();
    if (!isNaN(limite) && depart.getHours() >= limite) depart.setDate(depart.getDate() + 1);
    if (ouvres) while (depart.getDay() === 0 || depart.getDay() === 6) depart.setDate(depart.getDate() + 1);
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(el.getAttribute('data-langue') || 'fr', { weekday: 'short', day: 'numeric', month: 'short' });
    } catch (e) { return; }
    var debut = fmt.format(ajouterJours(depart, mini, ouvres)).replace(/ /g, ' ');
    var fin = fmt.format(ajouterJours(depart, maxi, ouvres)).replace(/ /g, ' ');
    var sur = modele.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    var html = sur.replace(/\[debut\]/g, '<strong>' + debut + '</strong>').replace(/\[fin\]/g, '<strong>' + fin + '</strong>');
    ecrire(titre, html);
  }

  function toutAppliquer(racine) {
    racine = racine || document;
    racine.querySelectorAll('[data-suggestions]').forEach(function (b) { try { evaluer(b); } catch (e) { console.warn('[panier] suggestions', e); } });
    racine.querySelectorAll('[data-minuteur]').forEach(peindreMinuteur);
    racine.querySelectorAll('[data-panier-livraison]').forEach(peindreLivraison);
  }

  /* le minuteur avance chaque seconde, où qu'il soit */
  setInterval(function () {
    document.querySelectorAll('[data-minuteur]').forEach(peindreMinuteur);
    document.querySelectorAll('[data-panier-livraison]').forEach(peindreLivraison);
  }, 1000);

  /* 4 bis. Avis du panier : rotation en fondu, pastilles cliquables (blocks/cart-social-proof).
     L'horloge avance d'une seconde à chaque tic ; survol, focus clavier, onglet caché ou
     « moins d'animations » la figent. */
  var moinsAnim = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function cartesAvis(el) { return Array.prototype.slice.call(el.querySelectorAll('[data-avis-carte]')); }
  function allerAvis(el, k, focus) {
    var cartes = cartesAvis(el);
    var n = cartes.length;
    if (n < 2) return;
    k = ((k % n) + n) % n;
    cartes.forEach(function (c, j) { c.classList.toggle('est-actif', j === k); });
    Array.prototype.forEach.call(el.querySelectorAll('[data-avis-point]'), function (p, j) {
      p.setAttribute('aria-pressed', j === k ? 'true' : 'false');
      if (focus && j === k) p.focus();
    });
    el.setAttribute('data-avis-i', String(k));
    el.__t = 0;
  }
  function ticAvis() {
    if (document.hidden || (moinsAnim && moinsAnim.matches)) return;
    document.querySelectorAll('[data-avis-panier]:not([data-fixe])').forEach(function (el) {
      if (el.__editeur || el.matches(':hover') || el.contains(document.activeElement)) return;
      el.__t = (el.__t || 0) + 1;
      if (el.__t >= (parseInt(el.getAttribute('data-intervalle'), 10) || 6)) {
        allerAvis(el, (parseInt(el.getAttribute('data-avis-i'), 10) || 0) + 1);
      }
    });
  }
  setInterval(ticAvis, 1000);
  document.addEventListener('keydown', function (e) {
    var p = e.target && e.target.closest && e.target.closest('[data-avis-point]');
    if (!p) return;
    var el = p.closest('[data-avis-panier]');
    var i = parseInt(el.getAttribute('data-avis-i'), 10) || 0;
    var sens = document.dir === 'rtl' ? -1 : 1;
    var k = null;
    if (e.key === 'ArrowRight') k = i + sens;
    else if (e.key === 'ArrowLeft') k = i - sens;
    else if (e.key === 'Home') k = 0;
    else if (e.key === 'End') k = cartesAvis(el).length - 1;
    if (k === null) return;
    e.preventDefault();
    allerAvis(el, k, true);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var carte = e.target && e.target.closest && e.target.closest('[data-avis-carte]');
    var el = e.target && e.target.closest && e.target.closest('[data-avis-panier]');
    if (!el) return;
    el.__editeur = true;
    if (carte) allerAvis(el, cartesAvis(el).indexOf(carte));
  });
  document.addEventListener('shopify:block:deselect', function (e) {
    var el = e.target && e.target.closest && e.target.closest('[data-avis-panier]');
    if (el) el.__editeur = false;
  });

  /* 4 ter. Paliers de quantité (blocks/cart-quantity-tiers) : le bouton met la ligne au palier.
     On passe par le composant du panier d'Horizon (même requête /cart/change, même re-rendu,
     mêmes événements que le sélecteur de quantité) ; à défaut, /cart/change.js puis rechargement. */
  function palier(bouton) {
    var ligne = parseInt(bouton.getAttribute('data-ligne'), 10);
    var qte = parseInt(bouton.getAttribute('data-quantite'), 10);
    var cle = bouton.getAttribute('data-cle');
    if (!ligne || !qte) return;
    var module = bouton.closest('.pq');
    var erreur = module && module.querySelector('.pq__erreur');
    if (erreur) { erreur.hidden = true; erreur.textContent = ''; }
    bouton.setAttribute('aria-busy', 'true');
    bouton.disabled = true;
    var composant = bouton.closest('cart-items-component') || document.querySelector('#cart-drawer cart-items-component');
    if (composant && typeof composant.updateQuantity === 'function') {
      Promise.resolve(composant.updateQuantity({ line: ligne, quantity: qte, action: 'change' }))
        .catch(function () {})
        .then(function () { if (bouton.isConnected) { bouton.removeAttribute('aria-busy'); bouton.disabled = false; } });
      return;
    }
    var routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
    var url = (routes.cart_change_url || racineUrl() + 'cart/change') + '.js';
    url = url.replace(/\.js\.js$/, '.js');
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(cle ? { id: cle, quantity: qte } : { line: ligne, quantity: qte })
    })
      .then(function (r) { return r.json(); })
      .then(function (rep) {
        if (rep && rep.status && erreur) { erreur.textContent = rep.description || rep.message || ''; erreur.hidden = false; return; }
        window.location.reload();
      })
      .catch(function () { window.location.reload(); })
      .then(function () { if (bouton.isConnected) { bouton.removeAttribute('aria-busy'); bouton.disabled = false; } });
  }

  /* 5. Ajout en un clic */
  function signaler(bouton, message) {
    var carte = bouton.closest('.sugg');
    if (!carte) return;
    var p = carte.querySelector('.sugg__erreur');
    if (!p) {
      p = document.createElement('p');
      p.className = 'sugg__erreur';
      p.setAttribute('role', 'alert');
      carte.appendChild(p);
    }
    p.textContent = message || '';
  }
  function liberer(bouton) {
    bouton.removeAttribute('aria-busy');
    bouton.disabled = false;
  }
  function ajouter(bouton, variante) {
    var routes = (typeof Theme !== 'undefined' && Theme.routes) || {};
    var urlAjout = routes.cart_add_url || racineUrl() + 'cart/add.js';
    var urlPanier = (routes.cart_url || racineUrl() + 'cart') + '.js';
    var sections = Array.prototype.map
      .call(document.querySelectorAll('cart-items-component'), function (e) { return e.dataset.sectionId; })
      .filter(Boolean);
    bouton.setAttribute('aria-busy', 'true');
    bouton.disabled = true;
    signaler(bouton, '');

    var corps = JSON.stringify({ items: [{ id: Number(variante), quantity: 1 }], sections: sections.join(',') });
    var envoyer = function () {
      return fetch(urlAjout, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: corps
      }).then(function (r) { return r.json(); });
    };

    import('@shopify/events')
      .then(function (ev) {
        var attente = ev.CartLinesUpdateEvent.createPromise();
        bouton.dispatchEvent(new ev.CartLinesUpdateEvent({
          action: 'add',
          context: 'cart',
          lines: [{ merchandiseId: String(variante), quantity: 1 }],
          promise: attente.promise
        }));
        return envoyer()
          .then(function (rep) {
            return fetch(urlPanier, { headers: { Accept: 'application/json' } })
              .then(function (r) { return r.json(); })
              .then(function (panier) {
                var erreur = Boolean(rep && rep.status);
                attente.resolve({
                  cart: ev.CartLinesUpdateEvent.createCartFromAjaxResponse(panier),
                  detail: {
                    items: panier.items,
                    sections: erreur ? undefined : rep.sections,
                    itemCount: 1,
                    didError: erreur,
                    source: 'panier-suggestions'
                  }
                });
                if (erreur) signaler(bouton, rep.description || rep.message);
              });
          })
          .catch(function (err) {
            attente.reject(err);
            throw err;
          });
      })
      .catch(function () {
        /* module d'événements indisponible : ajout simple puis page panier */
        return envoyer().then(function () { window.location.href = routes.cart_url || racineUrl() + 'cart'; });
      })
      .then(function () { if (bouton.isConnected) liberer(bouton); }, function () { if (bouton.isConnected) liberer(bouton); });
  }

  document.addEventListener('click', function (e) {
    var cible = e.target;
    if (!cible || !cible.closest) return;
    var point = cible.closest('[data-avis-point]');
    if (point) {
      var avis = point.closest('[data-avis-panier]');
      if (avis) allerAvis(avis, parseInt(point.getAttribute('data-avis-point'), 10) || 0);
      return;
    }
    var boutonPalier = cible.closest('[data-palier-ajout]');
    if (boutonPalier) {
      e.preventDefault();
      if (!boutonPalier.disabled && boutonPalier.getAttribute('aria-busy') !== 'true') palier(boutonPalier);
      return;
    }
    var bouton = cible.closest('[data-sugg-ajout]');
    if (bouton) {
      e.preventDefault();
      if (bouton.disabled || bouton.getAttribute('aria-busy') === 'true') return;
      var carte = bouton.closest('.sugg');
      var choix = carte && carte.querySelector('select[data-sugg-variante]');
      var variante = choix ? choix.value : bouton.getAttribute('data-variant-id');
      if (variante) ajouter(bouton, variante);
      return;
    }
    var fleche = cible.closest('[data-sugg-prec], [data-sugg-suiv]');
    if (fleche) {
      var bloc = fleche.closest('[data-suggestions]');
      var piste = bloc && bloc.querySelector('[data-sugg-piste]');
      if (!piste) return;
      var carteVisible = piste.querySelector('.sugg:not([hidden])');
      var pas = carteVisible ? carteVisible.getBoundingClientRect().width + 10 : piste.clientWidth * 0.8;
      var sens = fleche.hasAttribute('data-sugg-prec') ? -1 : 1;
      var doux = !(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
      piste.scrollBy({ left: sens * pas * (document.dir === 'rtl' ? -1 : 1), behavior: doux ? 'smooth' : 'auto' });
    }
  });

  /* flèches du carrousel : état à jour pendant le défilement */
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.nodeType === 1 && t.hasAttribute('data-sugg-piste')) {
      var bloc = t.closest('[data-suggestions]');
      if (bloc) majFleches(bloc);
    }
  }, true);

  /* 6. Re-rendu du tiroir : on réapplique, sans boucler sur nos propres écritures */
  var enCours = false;
  function brancher() {
    toutAppliquer(document);
    var tiroir = document.getElementById('cart-drawer');
    if (!tiroir || !window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      if (enCours) return;
      var utile = mutations.some(function (m) {
        var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
        return !(el && el.closest && el.closest('[data-panier-tic]'));
      });
      if (!utile) return;
      enCours = true;
      try { toutAppliquer(tiroir); } finally { enCours = false; }
    }).observe(tiroir, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['data-pret', 'data-panier'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', brancher);
  else brancher();

  /* éditeur : une règle sélectionnée reste visible, même si sa condition n'est pas remplie */
  document.addEventListener('shopify:block:select', function (e) {
    var regle = e.target && e.target.closest && e.target.closest('[data-sugg-regle]');
    document.querySelectorAll('[data-sugg-regle][data-force]').forEach(function (c) { c.removeAttribute('data-force'); });
    if (regle) {
      regle.setAttribute('data-force', '');
      regle.hidden = false;
      var bloc = regle.closest('[data-suggestions]');
      if (bloc) { bloc.removeAttribute('data-vide'); bloc.removeAttribute('data-pret'); }
    }
  });
  document.addEventListener('shopify:block:deselect', function () {
    document.querySelectorAll('[data-sugg-regle][data-force]').forEach(function (c) {
      c.removeAttribute('data-force');
      var bloc = c.closest('[data-suggestions]');
      if (bloc) bloc.removeAttribute('data-pret');
    });
    toutAppliquer(document);
  });
  document.addEventListener('shopify:section:load', function () { toutAppliquer(document); });
})();
